import template from './ko-field-input-phone.html';

class PhoneInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.readonly = ko.observable(params.readonly);
	}
}


export default {
	name: 'ko-field-input-phone',
	viewModel: PhoneInputComponentVM,
	module_type: 'ko',
	template: template
}
